/**
 * NOTE:
 * - R7 April [established:新設]
 */

import { t } from "i18next"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"
import { FormFieldsProp } from "../../../../molecules/FormFields/types"

type Params = {
  name: string
}

/**
 * Version management: Facility Status Form
 * @param {Moment} date
 * @param {Params} params
 * @return {FormFieldsProp|null}
 */
export function getSupportProgramNotPublicizedSubtraction(
  date: Moment,
  params: Params
) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
    case Version.R6_APRIL:
    case Version.R6_JUNE:
    case Version.R7_JANUARY:
      return null

    default:
      return r7April(params.name)
  }
}

/**
 * --------------------------------
 * @version R7_APRIL
 * --------------------------------
 */

function r7April(name: string): FormFieldsProp {
  return {
    // TODO: translate
    fieldLabel: "支援プログラム未公表減算",
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              { label: t("No"), value: "0" },
              { label: t("Yes"), value: "1" },
            ],
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version BASELINE
 * @version R6_APRIL
 * @version R6_JUNE
 * @version R6_JANUARY
 *
 * NONE
 * --------------------------------
 */
